import { isDeterministicImportJsx } from '@/lib/html-to-email/provenance'

export type ExactImportHtmlState =
  | 'not-applicable'
  | 'loading'
  | 'ready'
  | 'missing'

/**
 * One render-state contract shared by every canvas host. A deterministic
 * document never falls through to reconstructed TipTap pixels: it either has
 * its preserved HTML, is still loading it, or shows an explicit failure.
 */
export function resolveExactImportHtmlState({
  jsxSource,
  htmlSource,
  isHtmlResolved,
}: {
  jsxSource: string | null | undefined
  htmlSource: string | null | undefined
  isHtmlResolved: boolean
}): ExactImportHtmlState {
  if (!jsxSource || !isDeterministicImportJsx(jsxSource)) {
    return 'not-applicable'
  }
  if (typeof htmlSource === 'string' && htmlSource.trim().length > 0) {
    return 'ready'
  }
  return isHtmlResolved ? 'missing' : 'loading'
}
